
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "WutColorPicker3463610379",
      {"classes":{"root":"WutColorPicker3463610379__root","bip-bop-bup":"WutColorPicker3463610379__bip-bop-bup"},"vars":{"color-dot-size":"--WutColorPicker3463610379-color-dot-size"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  